import { type Analytics, AnalyticsBrowser } from '@customerio/cdp-analytics-browser'

declare global {
  interface Window {
    customerio?: Analytics
  }
}

export const useCustomerIo = () => {
  const load = async () => {
    // Disable in-app messaging for localhost to prevent interference with testing
    const anonymousInApp = location.hostname !== 'localhost'

    if (!import.meta.env.PUBLIC_CUSTOMER_IO_WRITE_KEY) {
      return
    }

    const customerio = AnalyticsBrowser.load(
      {
        writeKey: import.meta.env.PUBLIC_CUSTOMER_IO_WRITE_KEY,
      },
      {
        user: {
          cookie: {
            /**
             * Override the known user ID cookie (and localstorage) key to be
             * distinct from Segment's to prevent conflicts between the two
             * analytics libraries.
             *
             * Without this Customer.io will incorrectly identify users with
             * their numeric user ID which. Instead we (currently) use the
             * user's email as their unique identifier in Customer.io
             */
            key: 'cio_user_id',
          },
        },

        integrations: {
          'Customer.io In-App Plugin': {
            anonymousInApp,
          },
        },
      }
    )

    customerio
      .then(([analytics]) => {
        window.customerio = analytics

        analytics.page()
      })
      .then()
  }

  return {
    load,
  }
}
